import { useState } from 'react';
import l from '../../../../lang';
import { Urls } from '../../../../config/urls';
import CheckoutRedirectIcon from '../../../../assets/icons/api-solutions/checkout-redirect.svg?url';
import SubscriptionsIcon from '../../../../assets/icons/api-solutions/subscriptions.svg?url';
import RecurringPaymentIcon from '../../../../assets/icons/api-solutions/recurring-payment.svg?url';
import SplitPaymentsIcon from '../../../../assets/icons/api-solutions/split-payments.svg?url';
import OneClickUpsellIcon from '../../../../assets/icons/api-solutions/one-click-upsell.svg?url';
import TransparentCheckoutIcon from '../../../../assets/icons/api-solutions/transparent-checkout.svg?url';
import ApiSolutionItem, { SolutionConfig, SolutionId } from './api-solution-item';

const SOLUTIONS: SolutionConfig[] = [
  {
    id: 'checkoutRedirect',
    icon: CheckoutRedirectIcon,
    docsUrl: Urls.docs.apiSolutions.checkoutRedirect,
    difficulty: 'low',
  },
  {
    id: 'subscriptions',
    icon: SubscriptionsIcon,
    docsUrl: Urls.docs.apiSolutions.subscriptions,
    difficulty: 'low',
  },
  {
    id: 'recurringPayment',
    icon: RecurringPaymentIcon,
    docsUrl: Urls.docs.apiSolutions.recurringPayment,
    difficulty: 'medium',
  },
  {
    id: 'splitPayments',
    icon: SplitPaymentsIcon,
    docsUrl: Urls.docs.apiSolutions.splitPayments,
    difficulty: 'high',
  },
  {
    id: 'oneClickUpsell',
    icon: OneClickUpsellIcon,
    docsUrl: Urls.docs.apiSolutions.oneClickUpsell,
    difficulty: 'high',
  },
  {
    id: 'transparentCheckout',
    icon: TransparentCheckoutIcon,
    docsUrl: Urls.docs.apiSolutions.transparentCheckout,
    difficulty: 'high',
  },
];

const ApiSolutions = () => {
  const [expandedId, setExpandedId] = useState<SolutionId | false>(false);

  return (
    <div className="api_solutions">
      <h2 className="api_solutions__title">{l('paymentIntegration.api.page.solutions.title')}</h2>
      <p className="api_solutions__subtitle">{l('paymentIntegration.api.page.solutions.subtitle')}</p>
      <div className="api_solutions__grid">
        {SOLUTIONS.map(solution => (
          <ApiSolutionItem
            key={solution.id}
            solution={solution}
            expanded={expandedId === solution.id}
            onChange={nextExpanded => setExpandedId(nextExpanded ? solution.id : false)}
          />
        ))}
      </div>
    </div>
  );
};

export default ApiSolutions;
